var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-121"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.59,131.45c-8.72,0-155.4,1-164.61.67a.71.71,0,0,1-.36-1.32c5.81-2.87,12.4-2.3,18.44-4.33,3.55-1.2,5.73-3.52,8.2-6.19a17,17,0,0,1,7.63-5A16.16,16.16,0,0,1,86.2,115c3,.71,5.56,2.41,8.4,3.49,7.05,2.66,13.89.13,18.92-5.08,4.15-4.3,8.23-8.36,13.87-10.67,4.73-1.94,10-2.34,14.7-.2,5.38,2.43,9.07,7.34,14.12,10.28,6,3.51,13.16,2.68,19.77,3.73s11.7,6.63,17.5,9.84a12.39,12.39,0,0,0,6.33,2,38.33,38.33,0,0,0,3.85-.54c2-.25,3.9-.19,5.24,1.47C209.23,129.73,209.16,131.45,208.59,131.45Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.36,141.7c-6.36,0-113.45.7-120.18.49-.48,0-.74-.73-.26-1,4.24-2.1,9.05-1.68,13.46-3.16,2.6-.88,4.19-2.57,6-4.52a12.36,12.36,0,0,1,5.57-3.63,11.69,11.69,0,0,1,6.07-.19c2.17.51,4.06,1.76,6.13,2.54,5.14,1.94,10.14.1,13.82-3.71,3-3.14,6-6.1,10.12-7.79a13.48,13.48,0,0,1,10.73-.15c3.93,1.78,6.62,5.36,10.31,7.52,4.38,2.55,9.61,2,14.44,2.72s8.54,4.84,12.77,7.18a9.09,9.09,0,0,0,4.62,1.43,27,27,0,0,0,2.82-.4c1.45-.18,2.84-.13,3.82,1.08C706.83,140.44,706.78,141.7,706.36,141.7Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.06,165.51c-6.36,0-113.45.7-120.18.49-.48,0-.74-.73-.26-1,4.24-2.1,9-1.67,13.46-3.16,2.6-.87,4.19-2.57,6-4.52a12.41,12.41,0,0,1,5.57-3.63,11.69,11.69,0,0,1,6.07-.19c2.17.51,4.06,1.76,6.13,2.54,5.15,1.94,10.15.1,13.82-3.71,3-3.13,6-6.1,10.13-7.79a13.42,13.42,0,0,1,10.72-.14c3.93,1.78,6.63,5.35,10.32,7.51,4.37,2.55,9.6,1.95,14.43,2.72s8.54,4.84,12.78,7.18a9.06,9.06,0,0,0,4.62,1.43c.94,0,1.87-.28,2.81-.39,1.46-.18,2.84-.14,3.82,1.07C358.53,164.25,358.48,165.51,358.06,165.51Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.75,209.16c-6.36,0-113.45.7-120.18.49-.48,0-.74-.73-.26-1,4.24-2.1,9.05-1.68,13.46-3.17,2.59-.87,4.19-2.57,6-4.51a12.29,12.29,0,0,1,5.57-3.64,11.69,11.69,0,0,1,6.07-.19c2.17.52,4.06,1.76,6.13,2.54,5.14,1.95,10.14.1,13.82-3.71,3-3.13,6-6.09,10.12-7.78a13.44,13.44,0,0,1,10.73-.15c3.93,1.78,6.62,5.36,10.31,7.51,4.38,2.55,9.61,1.95,14.44,2.72s8.54,4.84,12.77,7.18a8.9,8.9,0,0,0,4.62,1.43c1,0,1.88-.28,2.82-.39,1.45-.18,2.84-.14,3.82,1.07C480.22,207.9,480.17,209.16,479.75,209.16Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.47,94.43c-.12.36-168.78,0-166.65,0,1,0-1.48-1.45-.53-1.91,5.49-2.73,11.5-2.81,17.48-3.36,3.49-.31,7.07-.82,10.21-2.47s5.16-4.56,7.42-7.23a31.71,31.71,0,0,1,28.8-10.91c12,1.88,21.44,11,33.46,12.7,7.21,1,14-1.79,21.09-2.77,5.81-.81,10.64.32,15.84,2.9,3.8,1.88,7.32,3.47,11.62,3.77,3.3.23,6.62-.15,9.93-.18a22.22,22.22,0,0,1,14.61,5.84C576.28,91.28,578,94.43,572.47,94.43Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 523.73,
    y: 107.22,
    width: 55.93,
    height: 293.17,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 532.41,
    y: 116.74,
    width: 10.87,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 546.32,
    y: 116.74,
    width: 10.87,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 532.41,
    y: 135.75,
    width: 10.87,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 546.32,
    y: 135.75,
    width: 10.87,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 532.41,
    y: 154.75,
    width: 10.87,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 546.32,
    y: 154.75,
    width: 10.87,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 532.41,
    y: 173.76,
    width: 10.87,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 546.32,
    y: 173.76,
    width: 10.87,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 532.41,
    y: 192.76,
    width: 10.87,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 546.32,
    y: 192.76,
    width: 10.87,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 532.41,
    y: 211.77,
    width: 10.87,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 546.32,
    y: 211.77,
    width: 10.87,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 532.41,
    y: 230.77,
    width: 10.87,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 546.32,
    y: 230.77,
    width: 10.87,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 532.41,
    y: 249.78,
    width: 10.87,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 546.32,
    y: 249.78,
    width: 10.87,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 532.41,
    y: 268.78,
    width: 10.87,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 546.32,
    y: 268.78,
    width: 10.87,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 532.41,
    y: 287.79,
    width: 10.87,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 546.32,
    y: 287.79,
    width: 10.87,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 532.41,
    y: 306.79,
    width: 10.87,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 546.32,
    y: 306.79,
    width: 10.87,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 532.41,
    y: 325.8,
    width: 10.87,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 546.32,
    y: 325.8,
    width: 10.87,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 532.41,
    y: 344.8,
    width: 10.87,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 546.32,
    y: 344.8,
    width: 10.87,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 532.41,
    y: 363.81,
    width: 10.87,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560.11,
    y: 363.81,
    width: 10.87,
    height: 11.19,
    transform: "translate(1131.09 738.81) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560.11,
    y: 344.8,
    width: 10.87,
    height: 11.19,
    transform: "translate(1131.09 700.8) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560.11,
    y: 325.8,
    width: 10.87,
    height: 11.19,
    transform: "translate(1131.09 662.79) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560.11,
    y: 306.79,
    width: 10.87,
    height: 11.19,
    transform: "translate(1131.09 624.78) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560.11,
    y: 287.79,
    width: 10.87,
    height: 11.19,
    transform: "translate(1131.09 586.77) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560.11,
    y: 268.78,
    width: 10.87,
    height: 11.19,
    transform: "translate(1131.09 548.76) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560.11,
    y: 249.78,
    width: 10.87,
    height: 11.19,
    transform: "translate(1131.09 510.75) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560.11,
    y: 230.77,
    width: 10.87,
    height: 11.19,
    transform: "translate(1131.09 472.74) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560.11,
    y: 211.77,
    width: 10.87,
    height: 11.19,
    transform: "translate(1131.09 434.73) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560.11,
    y: 192.76,
    width: 10.87,
    height: 11.19,
    transform: "translate(1131.09 396.72) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560.11,
    y: 173.76,
    width: 10.87,
    height: 11.19,
    transform: "translate(1131.09 358.71) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560.11,
    y: 154.75,
    width: 10.87,
    height: 11.19,
    transform: "translate(1131.09 320.7) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560.11,
    y: 135.75,
    width: 10.87,
    height: 11.19,
    transform: "translate(1131.09 282.69) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560.11,
    y: 116.74,
    width: 10.87,
    height: 11.19,
    transform: "translate(1131.09 244.68) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 546.32,
    y: 363.81,
    width: 10.87,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 579.66,
    y: 107.22,
    width: 44.1,
    height: 293.17,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610.23,
    y: 363.81,
    width: 8.98,
    height: 11.19,
    transform: "translate(1229.45 738.81) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598.75,
    y: 363.81,
    width: 8.98,
    height: 11.19,
    transform: "translate(1206.48 738.81) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610.23,
    y: 344.8,
    width: 8.98,
    height: 11.19,
    transform: "translate(1229.45 700.8) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598.75,
    y: 344.8,
    width: 8.98,
    height: 11.19,
    transform: "translate(1206.48 700.8) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610.23,
    y: 325.8,
    width: 8.98,
    height: 11.19,
    transform: "translate(1229.45 662.79) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598.75,
    y: 325.8,
    width: 8.98,
    height: 11.19,
    transform: "translate(1206.48 662.79) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610.23,
    y: 306.79,
    width: 8.98,
    height: 11.19,
    transform: "translate(1229.45 624.78) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598.75,
    y: 306.79,
    width: 8.98,
    height: 11.19,
    transform: "translate(1206.48 624.78) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610.23,
    y: 287.79,
    width: 8.98,
    height: 11.19,
    transform: "translate(1229.45 586.77) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598.75,
    y: 287.79,
    width: 8.98,
    height: 11.19,
    transform: "translate(1206.48 586.77) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610.23,
    y: 268.78,
    width: 8.98,
    height: 11.19,
    transform: "translate(1229.45 548.76) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598.75,
    y: 268.78,
    width: 8.98,
    height: 11.19,
    transform: "translate(1206.48 548.76) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610.23,
    y: 249.78,
    width: 8.98,
    height: 11.19,
    transform: "translate(1229.45 510.75) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598.75,
    y: 249.78,
    width: 8.98,
    height: 11.19,
    transform: "translate(1206.48 510.75) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610.23,
    y: 230.77,
    width: 8.98,
    height: 11.19,
    transform: "translate(1229.45 472.74) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598.75,
    y: 230.77,
    width: 8.98,
    height: 11.19,
    transform: "translate(1206.48 472.74) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610.23,
    y: 211.77,
    width: 8.98,
    height: 11.19,
    transform: "translate(1229.45 434.73) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598.75,
    y: 211.77,
    width: 8.98,
    height: 11.19,
    transform: "translate(1206.48 434.73) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610.23,
    y: 192.76,
    width: 8.98,
    height: 11.19,
    transform: "translate(1229.45 396.72) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598.75,
    y: 192.76,
    width: 8.98,
    height: 11.19,
    transform: "translate(1206.48 396.72) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610.23,
    y: 173.76,
    width: 8.98,
    height: 11.19,
    transform: "translate(1229.45 358.71) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598.75,
    y: 173.76,
    width: 8.98,
    height: 11.19,
    transform: "translate(1206.48 358.71) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610.23,
    y: 154.75,
    width: 8.98,
    height: 11.19,
    transform: "translate(1229.45 320.7) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598.75,
    y: 154.75,
    width: 8.98,
    height: 11.19,
    transform: "translate(1206.48 320.7) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610.23,
    y: 135.75,
    width: 8.98,
    height: 11.19,
    transform: "translate(1229.45 282.69) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598.75,
    y: 135.75,
    width: 8.98,
    height: 11.19,
    transform: "translate(1206.48 282.69) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610.23,
    y: 116.74,
    width: 8.98,
    height: 11.19,
    transform: "translate(1229.45 244.68) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.36,
    y: 116.74,
    width: 8.98,
    height: 11.19,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.36,
    y: 135.75,
    width: 8.98,
    height: 11.19,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.36,
    y: 154.75,
    width: 8.98,
    height: 11.19,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.36,
    y: 173.76,
    width: 8.98,
    height: 11.19,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.36,
    y: 192.76,
    width: 8.98,
    height: 11.19,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.36,
    y: 211.77,
    width: 8.98,
    height: 11.19,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.36,
    y: 230.77,
    width: 8.98,
    height: 11.19,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.36,
    y: 249.78,
    width: 8.98,
    height: 11.19,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.36,
    y: 268.78,
    width: 8.98,
    height: 11.19,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.36,
    y: 287.79,
    width: 8.98,
    height: 11.19,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.36,
    y: 306.79,
    width: 8.98,
    height: 11.19,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.36,
    y: 325.8,
    width: 8.98,
    height: 11.19,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.36,
    y: 344.8,
    width: 8.98,
    height: 11.19,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.36,
    y: 363.81,
    width: 8.98,
    height: 11.19,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598.75,
    y: 116.74,
    width: 8.98,
    height: 11.19,
    transform: "translate(1206.48 244.68) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.88,
    y: 84.48,
    width: 67.33,
    height: 315.91,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.26,
    y: 78.19,
    width: 68.95,
    height: 6.29,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.97,
    y: 93.75,
    width: 6.82,
    height: 306.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.05,
    y: 93.75,
    width: 6.82,
    height: 306.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.13,
    y: 93.75,
    width: 6.82,
    height: 306.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.22,
    y: 93.75,
    width: 6.82,
    height: 306.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.3,
    y: 93.75,
    width: 6.82,
    height: 306.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.97,
    y: 101.7,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.05,
    y: 101.7,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.13,
    y: 101.7,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.22,
    y: 101.7,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.3,
    y: 101.7,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.97,
    y: 121.88,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.05,
    y: 121.88,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.13,
    y: 121.88,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.22,
    y: 121.88,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.3,
    y: 121.88,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.97,
    y: 142.06,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.05,
    y: 142.06,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.13,
    y: 142.06,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.22,
    y: 142.06,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.3,
    y: 142.06,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.97,
    y: 162.25,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.05,
    y: 162.25,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.13,
    y: 162.25,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.22,
    y: 162.25,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.3,
    y: 162.25,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.97,
    y: 182.43,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.05,
    y: 182.43,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.13,
    y: 182.43,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.22,
    y: 182.43,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.3,
    y: 182.43,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.97,
    y: 202.61,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.05,
    y: 202.61,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.13,
    y: 202.61,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.22,
    y: 202.61,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.3,
    y: 202.61,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.97,
    y: 222.79,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.05,
    y: 222.79,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.13,
    y: 222.79,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.22,
    y: 222.79,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.3,
    y: 222.79,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.97,
    y: 242.98,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.05,
    y: 242.98,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.13,
    y: 242.98,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.22,
    y: 242.98,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.3,
    y: 242.98,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.97,
    y: 263.16,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.05,
    y: 263.16,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.13,
    y: 263.16,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.22,
    y: 263.16,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.3,
    y: 263.16,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.97,
    y: 283.34,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.05,
    y: 283.34,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.13,
    y: 283.34,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.22,
    y: 283.34,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.3,
    y: 283.34,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.97,
    y: 303.52,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.05,
    y: 303.52,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.13,
    y: 303.52,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.22,
    y: 303.52,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.3,
    y: 303.52,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.97,
    y: 323.7,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.05,
    y: 323.7,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.13,
    y: 323.7,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.22,
    y: 323.7,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.3,
    y: 323.7,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.97,
    y: 343.89,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.05,
    y: 343.89,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.13,
    y: 343.89,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.22,
    y: 343.89,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.3,
    y: 343.89,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.97,
    y: 364.07,
    width: 6.82,
    height: 36.32,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.05,
    y: 364.07,
    width: 6.82,
    height: 36.32,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.13,
    y: 364.07,
    width: 6.82,
    height: 36.32,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.22,
    y: 364.07,
    width: 6.82,
    height: 36.32,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.3,
    y: 364.07,
    width: 6.82,
    height: 36.32,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.21,
    y: 84.48,
    width: 43.22,
    height: 315.91,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.21,
    y: 78.19,
    width: 45.1,
    height: 6.29,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.29,
    y: 93.75,
    width: 6.82,
    height: 306.64,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.38,
    y: 93.75,
    width: 6.82,
    height: 306.64,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.46,
    y: 93.75,
    width: 6.82,
    height: 306.64,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.29,
    y: 101.7,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.38,
    y: 101.7,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.46,
    y: 101.7,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.29,
    y: 121.88,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.38,
    y: 121.88,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.46,
    y: 121.88,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.29,
    y: 142.06,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.38,
    y: 142.06,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.46,
    y: 142.06,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.29,
    y: 162.25,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.38,
    y: 162.25,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.46,
    y: 162.25,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.29,
    y: 182.43,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.38,
    y: 182.43,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.46,
    y: 182.43,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.29,
    y: 202.61,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.38,
    y: 202.61,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.46,
    y: 202.61,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.29,
    y: 222.79,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.38,
    y: 222.79,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.46,
    y: 222.79,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.29,
    y: 242.98,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.38,
    y: 242.98,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.46,
    y: 242.98,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.29,
    y: 263.16,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.38,
    y: 263.16,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.46,
    y: 263.16,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.29,
    y: 283.34,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.38,
    y: 283.34,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.46,
    y: 283.34,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.29,
    y: 303.52,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.38,
    y: 303.52,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.46,
    y: 303.52,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.29,
    y: 323.7,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.38,
    y: 323.7,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.46,
    y: 323.7,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.29,
    y: 343.89,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.38,
    y: 343.89,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.46,
    y: 343.89,
    width: 6.82,
    height: 12.42,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.29,
    y: 364.07,
    width: 6.82,
    height: 36.32,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.38,
    y: 364.07,
    width: 6.82,
    height: 36.32,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.46,
    y: 364.07,
    width: 6.82,
    height: 36.32,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.85,
    y: 190.54,
    width: 55.33,
    height: 209.85,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.72,
    y: 176.63,
    width: 47.46,
    height: 13.92,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.91,
    y: 197.81,
    width: 43.2,
    height: 156.87,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.91,
    y: 212.78,
    width: 43.2,
    height: 3.71,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.91,
    y: 228.13,
    width: 43.2,
    height: 3.71,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.91,
    y: 243.49,
    width: 43.2,
    height: 3.71,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.91,
    y: 258.84,
    width: 43.2,
    height: 3.71,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.91,
    y: 274.2,
    width: 43.2,
    height: 3.71,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.91,
    y: 289.55,
    width: 43.2,
    height: 3.71,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.91,
    y: 304.91,
    width: 43.2,
    height: 3.71,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.91,
    y: 320.26,
    width: 43.2,
    height: 3.71,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.91,
    y: 335.62,
    width: 43.2,
    height: 3.71,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.91,
    y: 350.97,
    width: 43.2,
    height: 3.71,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.18,
    y: 190.54,
    width: 34.66,
    height: 209.85,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.18,
    y: 176.63,
    width: 29.46,
    height: 13.92,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.96,
    y: 197.81,
    width: 26.65,
    height: 156.87,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.96,
    y: 212.78,
    width: 26.65,
    height: 3.71,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.96,
    y: 228.13,
    width: 26.65,
    height: 3.71,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.96,
    y: 243.49,
    width: 26.65,
    height: 3.71,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.96,
    y: 258.84,
    width: 26.65,
    height: 3.71,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.96,
    y: 274.2,
    width: 26.65,
    height: 3.71,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.96,
    y: 289.55,
    width: 26.65,
    height: 3.71,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.96,
    y: 304.91,
    width: 26.65,
    height: 3.71,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.96,
    y: 320.26,
    width: 26.65,
    height: 3.71,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.96,
    y: 335.62,
    width: 26.65,
    height: 3.71,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.96,
    y: 350.97,
    width: 26.65,
    height: 3.71,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 626.98,
    y: 194.08,
    width: 29.55,
    height: 34.91,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 656.53,
    y: 194.08,
    width: 18.74,
    height: 36.19,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 657.92,
    y: 209.5,
    width: 18.6,
    height: 20.77,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 676.52,
    y: 209.5,
    width: 11.6,
    height: 20.77,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 615.64,
    y: 226.72,
    width: 47.79,
    height: 173.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 621.11,
    y: 234.19,
    width: 15.03,
    height: 6.14,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640.33,
    y: 234.19,
    width: 15.03,
    height: 6.14,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 621.11,
    y: 244.61,
    width: 15.03,
    height: 6.14,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640.33,
    y: 244.61,
    width: 15.03,
    height: 6.14,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 621.11,
    y: 255.03,
    width: 15.03,
    height: 6.14,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640.33,
    y: 255.03,
    width: 15.03,
    height: 6.14,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 621.11,
    y: 265.46,
    width: 15.03,
    height: 6.14,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640.33,
    y: 265.46,
    width: 15.03,
    height: 6.14,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 621.11,
    y: 275.88,
    width: 15.03,
    height: 6.14,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640.33,
    y: 275.88,
    width: 15.03,
    height: 6.14,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 621.11,
    y: 286.31,
    width: 15.03,
    height: 6.14,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640.33,
    y: 286.31,
    width: 15.03,
    height: 6.14,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 621.11,
    y: 296.73,
    width: 15.03,
    height: 6.14,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640.33,
    y: 296.73,
    width: 15.03,
    height: 6.14,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 621.11,
    y: 307.16,
    width: 15.03,
    height: 6.14,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640.33,
    y: 307.16,
    width: 15.03,
    height: 6.14,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 621.11,
    y: 317.58,
    width: 15.03,
    height: 6.14,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640.33,
    y: 317.58,
    width: 15.03,
    height: 6.14,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 621.11,
    y: 328,
    width: 15.03,
    height: 6.14,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640.33,
    y: 328,
    width: 15.03,
    height: 6.14,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 621.11,
    y: 338.43,
    width: 15.03,
    height: 6.14,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640.33,
    y: 338.43,
    width: 15.03,
    height: 6.14,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 621.11,
    y: 348.85,
    width: 15.03,
    height: 6.14,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640.33,
    y: 348.85,
    width: 15.03,
    height: 6.14,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 621.11,
    y: 359.28,
    width: 15.03,
    height: 6.14,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640.33,
    y: 359.28,
    width: 15.03,
    height: 6.14,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 621.11,
    y: 369.7,
    width: 15.03,
    height: 6.14,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640.33,
    y: 369.7,
    width: 15.03,
    height: 6.14,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 663.43,
    y: 226.72,
    width: 38.72,
    height: 173.67,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 685.93,
    y: 369.7,
    width: 12.34,
    height: 6.14,
    transform: "translate(1384.2 745.54) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 670.15,
    y: 369.7,
    width: 12.34,
    height: 6.14,
    transform: "translate(1352.63 745.54) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 685.93,
    y: 359.28,
    width: 12.34,
    height: 6.14,
    transform: "translate(1384.2 724.69) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 670.15,
    y: 359.28,
    width: 12.34,
    height: 6.14,
    transform: "translate(1352.63 724.69) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 685.93,
    y: 348.85,
    width: 12.34,
    height: 6.14,
    transform: "translate(1384.2 703.84) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 670.15,
    y: 348.85,
    width: 12.34,
    height: 6.14,
    transform: "translate(1352.63 703.84) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 685.93,
    y: 338.43,
    width: 12.34,
    height: 6.14,
    transform: "translate(1384.2 683) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 670.15,
    y: 338.43,
    width: 12.34,
    height: 6.14,
    transform: "translate(1352.63 683) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 685.93,
    y: 328,
    width: 12.34,
    height: 6.14,
    transform: "translate(1384.2 662.15) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 670.15,
    y: 328,
    width: 12.34,
    height: 6.14,
    transform: "translate(1352.63 662.15) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 685.93,
    y: 317.58,
    width: 12.34,
    height: 6.14,
    transform: "translate(1384.2 641.3) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 670.15,
    y: 317.58,
    width: 12.34,
    height: 6.14,
    transform: "translate(1352.63 641.3) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 685.93,
    y: 307.16,
    width: 12.34,
    height: 6.14,
    transform: "translate(1384.2 620.45) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 670.15,
    y: 307.16,
    width: 12.34,
    height: 6.14,
    transform: "translate(1352.63 620.45) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 685.93,
    y: 296.73,
    width: 12.34,
    height: 6.14,
    transform: "translate(1384.2 599.6) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 670.15,
    y: 296.73,
    width: 12.34,
    height: 6.14,
    transform: "translate(1352.63 599.6) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 685.93,
    y: 286.31,
    width: 12.34,
    height: 6.14,
    transform: "translate(1384.2 578.75) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 670.15,
    y: 286.31,
    width: 12.34,
    height: 6.14,
    transform: "translate(1352.63 578.75) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 685.93,
    y: 275.88,
    width: 12.34,
    height: 6.14,
    transform: "translate(1384.2 557.91) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 670.15,
    y: 275.88,
    width: 12.34,
    height: 6.14,
    transform: "translate(1352.63 557.91) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 685.93,
    y: 265.46,
    width: 12.34,
    height: 6.14,
    transform: "translate(1384.2 537.06) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 670.15,
    y: 265.46,
    width: 12.34,
    height: 6.14,
    transform: "translate(1352.63 537.06) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 685.93,
    y: 255.03,
    width: 12.34,
    height: 6.14,
    transform: "translate(1384.2 516.21) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 670.15,
    y: 255.03,
    width: 12.34,
    height: 6.14,
    transform: "translate(1352.63 516.21) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 685.93,
    y: 244.61,
    width: 12.34,
    height: 6.14,
    transform: "translate(1384.2 495.36) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 670.15,
    y: 244.61,
    width: 12.34,
    height: 6.14,
    transform: "translate(1352.63 495.36) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 685.93,
    y: 234.19,
    width: 12.34,
    height: 6.14,
    transform: "translate(1384.2 474.51) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 670.15,
    y: 234.19,
    width: 12.34,
    height: 6.14,
    transform: "translate(1352.63 474.51) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.3,
    y: 262.24,
    width: 56.47,
    height: 138.15,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.18,
    y: 274.2,
    width: 9.99,
    height: 8.46,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.18,
    y: 292.28,
    width: 9.99,
    height: 8.46,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.18,
    y: 310.36,
    width: 9.99,
    height: 8.46,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.18,
    y: 328.43,
    width: 9.99,
    height: 8.46,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.18,
    y: 346.51,
    width: 9.99,
    height: 8.46,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.18,
    y: 364.59,
    width: 9.99,
    height: 8.46,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.18,
    y: 382.67,
    width: 9.99,
    height: 8.46,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.55,
    y: 274.2,
    width: 9.99,
    height: 8.46,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.55,
    y: 292.28,
    width: 9.99,
    height: 8.46,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.55,
    y: 310.36,
    width: 9.99,
    height: 8.46,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.55,
    y: 328.43,
    width: 9.99,
    height: 8.46,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.55,
    y: 346.51,
    width: 9.99,
    height: 8.46,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.55,
    y: 364.59,
    width: 9.99,
    height: 8.46,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.55,
    y: 382.67,
    width: 9.99,
    height: 8.46,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.89,
    y: 274.2,
    width: 9.99,
    height: 8.46,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.89,
    y: 292.28,
    width: 9.99,
    height: 8.46,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.89,
    y: 310.36,
    width: 9.99,
    height: 8.46,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.89,
    y: 328.43,
    width: 9.99,
    height: 8.46,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.89,
    y: 346.51,
    width: 9.99,
    height: 8.46,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.89,
    y: 364.59,
    width: 9.99,
    height: 8.46,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.89,
    y: 382.67,
    width: 9.99,
    height: 8.46,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.17,
    y: 247.85,
    width: 37.59,
    height: 14.39,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.93,
    y: 238.94,
    width: 23.83,
    height: 8.91,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.76,
    y: 262.24,
    width: 39.62,
    height: 138.15,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.19,
    y: 381.32,
    width: 8.13,
    height: 8.46,
    transform: "translate(608.51 771.1) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.19,
    y: 363.24,
    width: 8.13,
    height: 8.46,
    transform: "translate(608.51 734.95) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.19,
    y: 345.16,
    width: 8.13,
    height: 8.46,
    transform: "translate(608.51 698.79) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.19,
    y: 327.08,
    width: 8.13,
    height: 8.46,
    transform: "translate(608.51 662.63) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.19,
    y: 309.01,
    width: 8.13,
    height: 8.46,
    transform: "translate(608.51 626.48) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.19,
    y: 290.93,
    width: 8.13,
    height: 8.46,
    transform: "translate(608.51 590.32) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.19,
    y: 272.85,
    width: 8.13,
    height: 8.46,
    transform: "translate(608.51 554.17) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.49,
    y: 381.32,
    width: 8.13,
    height: 8.46,
    transform: "translate(585.11 771.1) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.49,
    y: 363.24,
    width: 8.13,
    height: 8.46,
    transform: "translate(585.11 734.95) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.49,
    y: 345.16,
    width: 8.13,
    height: 8.46,
    transform: "translate(585.11 698.79) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.49,
    y: 327.08,
    width: 8.13,
    height: 8.46,
    transform: "translate(585.11 662.63) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.49,
    y: 309.01,
    width: 8.13,
    height: 8.46,
    transform: "translate(585.11 626.48) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.49,
    y: 290.93,
    width: 8.13,
    height: 8.46,
    transform: "translate(585.11 590.32) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.49,
    y: 272.85,
    width: 8.13,
    height: 8.46,
    transform: "translate(585.11 554.17) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.82,
    y: 381.32,
    width: 8.13,
    height: 8.46,
    transform: "translate(561.77 771.1) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.82,
    y: 363.24,
    width: 8.13,
    height: 8.46,
    transform: "translate(561.77 734.95) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.82,
    y: 345.16,
    width: 8.13,
    height: 8.46,
    transform: "translate(561.77 698.79) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.82,
    y: 327.08,
    width: 8.13,
    height: 8.46,
    transform: "translate(561.77 662.63) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.82,
    y: 309.01,
    width: 8.13,
    height: 8.46,
    transform: "translate(561.77 626.48) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.82,
    y: 290.93,
    width: 8.13,
    height: 8.46,
    transform: "translate(561.77 590.32) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.82,
    y: 272.85,
    width: 8.13,
    height: 8.46,
    transform: "translate(561.77 554.17) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.76,
    y: 247.85,
    width: 33.62,
    height: 14.39,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.76,
    y: 238.94,
    width: 18.22,
    height: 8.91,
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-121"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47,441.44c210.13-.62,445.85-.62,656,0-210.13.61-445.85.61-656,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,400.39c210.13-.61,445.85-.62,656,0-210.13.62-445.85.61-656,0Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Trees--inject-121"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71,355.33s12.19,27.07-7.71,27.1-7-28-7-28-4.61-2,.71-17.14,7.72-15.12,9.94-15.12c2.8,0,5.42,6.54,3.52,16.58C70.44,338.75,77.45,351.27,71,355.33Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.55 400.39 63.43 359.59 65.39 400.39 61.55 400.39",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "62.66 376.69 69.89 368.24 64.22 377.81 62.66 376.69",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.56,358.24s-5.67-2.24-10.17,5.6c-4.61,8,1.19,13.33,5.78,10.17,0,0,3.61,7.56,10.81,5.75s8.37-7.57,8.37-7.57,6.4.44,6.57-4.33-4.51-9-4.51-9-.28-11.89-8-11.79S314.56,358.24,314.56,358.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.88 400.37 321.46 364.99 323.12 400.37 319.88 400.37",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321 378.29 316.01 368.37 321.81 376.74 321 378.29",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.2,358.24s-5.68-2.24-10.18,5.6c-4.6,8,1.19,13.33,5.78,10.17,0,0,3.61,7.56,10.82,5.75s8.37-7.57,8.37-7.57,6.39.44,6.57-4.33-4.52-9-4.52-9-.28-11.89-8-11.79S219.2,358.24,219.2,358.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.51 400.37 226.1 364.99 227.76 400.37 224.51 400.37",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.63 378.29 220.65 368.37 226.44 376.74 225.63 378.29",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.13,355.15s12.19,27.07-7.71,27.09-7-28-7-28-4.61-2,.72-17.14S687.82,322,690,322c2.81,0,5.42,6.53,3.52,16.58C693.56,338.57,700.58,351.09,694.13,355.15Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "684.68 400.21 686.55 359.4 688.51 400.2 684.68 400.21",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "685.79 376.51 693.01 368.06 687.35 377.63 685.79 376.51",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.73,355.15s12.19,27.07-7.71,27.09-7-28-7-28-4.61-2,.72-17.14S611.43,322,613.64,322c2.81,0,5.43,6.53,3.52,16.58C617.16,338.57,624.18,351.09,617.73,355.15Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "608.28 400.21 610.15 359.4 612.12 400.2 608.28 400.21",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "609.39 376.51 616.61 368.06 610.95 377.63 609.39 376.51",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.19,360.9s-10.62,23.74,6.81,23.72,6.11-24.54,6.11-24.54,4-1.78-.67-15-6.78-13.23-8.73-13.22c-2.45,0-4.73,5.73-3,14.52C287.66,346.37,281.54,357.36,287.19,360.9Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.56 400.35 293.84 364.61 292.2 400.35 295.56 400.35",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "294.54 379.6 288.2 372.2 293.18 380.58 294.54 379.6",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.38,360.9s-10.62,23.74,6.81,23.72,6.1-24.54,6.1-24.54,4-1.78-.66-15-6.78-13.23-8.73-13.22c-2.45,0-4.73,5.73-3,14.52C444.85,346.37,438.73,357.36,444.38,360.9Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "452.75 400.35 451.03 364.61 449.39 400.35 452.75 400.35",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "451.73 379.6 445.39 372.2 450.37 380.58 451.73 379.6",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.65,358.1s-5.68-2.25-10.18,5.59c-4.61,8.05,1.19,13.33,5.78,10.18,0,0,3.61,7.56,10.82,5.75s8.36-7.58,8.36-7.58,6.4.45,6.57-4.33-4.51-9-4.51-9-.28-11.89-8-11.79S628.65,358.1,628.65,358.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "633.96 400.23 635.54 364.85 637.2 400.22 633.96 400.23",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "635.06 378.1 630.09 368.22 636.04 376.58 635.06 378.1",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Birds--inject-121"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M472.74,200.89a18.79,18.79,0,0,0-2.4-1,9.86,9.86,0,0,0-2.61-.6,2.21,2.21,0,0,0-.81.09,2.41,2.41,0,0,0-.25.11l-.16.12c-.1.07-.18.15-.28.23a12.26,12.26,0,0,0-1,1c-.58.66-1.11,1.35-1.63,2.06l.65-.23a18.91,18.91,0,0,0-2.67-.56,10.45,10.45,0,0,0-1.39-.1,4.76,4.76,0,0,0-.74.05,2.13,2.13,0,0,0-.4.1,2.42,2.42,0,0,0-.4.19,4.83,4.83,0,0,0-1.05,1c-.29.36-.54.73-.79,1.11a17.92,17.92,0,0,0-1.24,2.38c.58-.69,1.13-1.38,1.72-2,.29-.33.58-.65.89-.94a4.61,4.61,0,0,1,.94-.73,2.36,2.36,0,0,1,1-.1,9.14,9.14,0,0,1,1.25.17c.84.15,1.69.36,2.51.58l.41.11.24-.34c.48-.68,1-1.36,1.52-2a10.35,10.35,0,0,1,.8-.92l.21-.2.09-.08,0,0a1.24,1.24,0,0,1,.46-.09,12.49,12.49,0,0,1,2.46.24C471,200.56,471.89,200.74,472.74,200.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.32,226.33a29.38,29.38,0,0,0-3.21-2.2,15,15,0,0,0-3.66-1.65,3.34,3.34,0,0,0-1.22-.1,1.24,1.24,0,0,0-.4.1l-.27.12c-.18.08-.32.17-.48.25a18.81,18.81,0,0,0-1.67,1.14c-1.06.8-2,1.66-3,2.54l1-.14a29.6,29.6,0,0,0-3.75-1.61,17.55,17.55,0,0,0-2-.55,7.53,7.53,0,0,0-1.1-.13,4.24,4.24,0,0,0-.61,0c-.21,0-.44.11-.64.16a7,7,0,0,0-1.84,1.18,18.1,18.1,0,0,0-1.49,1.41,25.12,25.12,0,0,0-2.51,3.13c1-.84,2.05-1.69,3.11-2.47a18.22,18.22,0,0,1,1.58-1.12,6.77,6.77,0,0,1,1.59-.8,3.62,3.62,0,0,1,1.57.16,13.88,13.88,0,0,1,1.78.61c1.18.47,2.38,1,3.52,1.59l.57.28.45-.43c.9-.87,1.86-1.71,2.82-2.52a16.7,16.7,0,0,1,1.45-1.13c.12-.07.24-.16.36-.22l.16-.09s0,0,.06,0a2,2,0,0,1,.7,0,18.59,18.59,0,0,1,3.55,1.07C460.93,225.35,462.12,225.85,463.32,226.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.79,123.9a18.49,18.49,0,0,0-2.19-1.4,10,10,0,0,0-2.48-1,2.36,2.36,0,0,0-.82,0,1.86,1.86,0,0,0-.26.08l-.18.09a3.14,3.14,0,0,0-.31.18,11.76,11.76,0,0,0-1.09.79c-.69.56-1.32,1.15-1.95,1.76l.67-.12a22.86,22.86,0,0,0-2.53-1c-.44-.12-.89-.24-1.36-.32a4.42,4.42,0,0,0-.74-.07,3,3,0,0,0-.41,0,2.9,2.9,0,0,0-.42.12,4.78,4.78,0,0,0-1.21.83,12.41,12.41,0,0,0-.95,1,17.68,17.68,0,0,0-1.62,2.14c.68-.58,1.34-1.17,2-1.72.34-.27.69-.54,1-.77a4.5,4.5,0,0,1,1-.57,2.46,2.46,0,0,1,1.05.07,11,11,0,0,1,1.2.37c.8.29,1.61.63,2.38,1l.39.17.29-.29c.58-.6,1.21-1.19,1.83-1.75a11.09,11.09,0,0,1,.94-.78c.08,0,.16-.12.24-.16l.1-.06s0,0,.05,0a1.3,1.3,0,0,1,.46,0,13.28,13.28,0,0,1,2.39.64C265.17,123.3,266,123.61,266.79,123.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.51,120.41a28.53,28.53,0,0,0-2.42-3.06,14.93,14.93,0,0,0-3-2.66,3.37,3.37,0,0,0-1.13-.46,1.36,1.36,0,0,0-.41,0,2.53,2.53,0,0,0-.3,0l-.53.11a16.81,16.81,0,0,0-1.94.58c-1.24.45-2.42,1-3.62,1.54l1,.16a30.12,30.12,0,0,0-3.11-2.64,15,15,0,0,0-1.76-1.12,8.57,8.57,0,0,0-1-.47,4.78,4.78,0,0,0-.6-.15,4.68,4.68,0,0,0-.66,0,7,7,0,0,0-2.1.58c-.64.27-1.24.58-1.84.9a25.92,25.92,0,0,0-3.33,2.25c1.24-.5,2.47-1,3.7-1.44a16.5,16.5,0,0,1,1.85-.59,6.15,6.15,0,0,1,1.76-.29,3.42,3.42,0,0,1,1.44.61,14.36,14.36,0,0,1,1.52,1.11c1,.8,2,1.68,2.89,2.56l.46.44.56-.28c1.12-.56,2.29-1.08,3.44-1.57a15.71,15.71,0,0,1,1.72-.64,3.59,3.59,0,0,1,.41-.11l.18,0h.07a2.16,2.16,0,0,1,.67.21A19.1,19.1,0,0,1,292.5,118C293.51,118.76,294.49,119.59,295.51,120.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.06,220.09a28.53,28.53,0,0,0-2.42-3.06,14.63,14.63,0,0,0-3-2.66,3.1,3.1,0,0,0-1.13-.46,1.76,1.76,0,0,0-.41,0l-.29,0c-.2,0-.36.07-.54.1a18.13,18.13,0,0,0-1.93.59c-1.25.45-2.43,1-3.63,1.54l1,.16a28.93,28.93,0,0,0-3.11-2.64,16.53,16.53,0,0,0-1.76-1.13,7.19,7.19,0,0,0-1-.46,3.64,3.64,0,0,0-.59-.15,4.87,4.87,0,0,0-.66,0,6.94,6.94,0,0,0-2.11.58,16.35,16.35,0,0,0-1.83.9,26,26,0,0,0-3.34,2.24c1.25-.49,2.47-1,3.71-1.44.61-.22,1.23-.43,1.84-.59a6.94,6.94,0,0,1,1.76-.29,3.74,3.74,0,0,1,1.45.61,15.48,15.48,0,0,1,1.51,1.12c1,.79,2,1.68,2.89,2.56l.46.44.56-.28c1.12-.56,2.29-1.08,3.44-1.57a16.64,16.64,0,0,1,1.72-.65l.41-.1.18,0s0,0,.07,0a1.92,1.92,0,0,1,.67.21,18.67,18.67,0,0,1,3.07,2.08C499.06,218.44,500.05,219.27,501.06,220.09Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lines--inject-121"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.23,278.57a323.57,323.57,0,0,1-36.32,0,323.57,323.57,0,0,1,36.32,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2,290.52a344,344,0,0,1-37.45,0,339,339,0,0,1,37.45,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.28,283.1c-14.55.68-29.22.68-43.78,0,14.56-.69,29.23-.69,43.78,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,214.63a323.57,323.57,0,0,1-36.32,0,323.57,323.57,0,0,1,36.32,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.93,263.31a344.19,344.19,0,0,1-37.46,0,344.19,344.19,0,0,1,37.46,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.91,254.56c-14.56.68-29.23.68-43.79,0,14.56-.68,29.23-.68,43.79,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.24,441.44l7.2-1.3s-7.66-7.86-3-12.69,11.8-.56,11.8-.56S62.18,415.4,71.06,413s16.71,14.78,16.71,14.78,1.3-4,7.94-2.45,11.88,10.62,11.88,10.62l82.25,5.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.24,441.44l7.19-1.35a16.89,16.89,0,0,1-3.82-5.52c-2.38-4.87,1-9.41,6.19-9.57a13.28,13.28,0,0,1,6.56,1.75l-.26.16a19.57,19.57,0,0,1,.34-5.18c1.28-7.67,9.17-12.29,15.53-6.6,4,3.35,6.73,7.91,9,12.55l-.42,0a4.46,4.46,0,0,1,2.29-2.33c5.26-2.13,10.75,1.48,14.1,5.37a25.88,25.88,0,0,1,3.66,5.05l82.24,5.65-82.26-5.34c-.1,0-.08,0-.13-.08a34.19,34.19,0,0,0-3.77-5c-2.75-3.07-6.37-5.82-10.67-5.8-2-.08-4.26.74-5,2.67l-.2.47-.22-.45c-2.25-4.55-5-9-8.89-12.37-4.2-3.84-9.86-3.07-13,1.63a16.48,16.48,0,0,0-2.22,9.76l0,.31-.27-.15a13,13,0,0,0-6.38-1.74c-3.25,0-6.81,2.46-6.73,5.95s2.25,6.43,4.44,8.92h-.07l-7.21,1.26Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-121"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.91,441.44l7.19-1.3s-7.66-7.86-3-12.69,11.8-.56,11.8-.56-1.1-11.49,7.79-13.9,16.7,14.78,16.7,14.78,1.31-4,7.94-2.45,11.88,10.62,11.88,10.62l82.25,5.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.91,441.44l7.18-1.35a17.2,17.2,0,0,1-3.82-5.52c-2.38-4.87,1-9.41,6.19-9.57A13.23,13.23,0,0,1,83,426.75l-.25.16a19.57,19.57,0,0,1,.34-5.18c1.27-7.67,9.16-12.29,15.52-6.6,4,3.35,6.74,7.91,9,12.55l-.41,0a4.46,4.46,0,0,1,2.29-2.33c5.26-2.13,10.74,1.48,14.09,5.37a25.88,25.88,0,0,1,3.66,5.05l82.24,5.65-82.26-5.34c-.1,0-.08,0-.12-.08a35.66,35.66,0,0,0-3.77-5c-2.75-3.07-6.38-5.82-10.67-5.8-2-.08-4.26.74-5,2.67l-.19.47-.22-.45c-2.26-4.55-5-9-8.9-12.37-4.2-3.84-9.86-3.07-13,1.63a16.49,16.49,0,0,0-2.23,9.76l0,.31-.27-.15a12.89,12.89,0,0,0-6.38-1.74c-3.25,0-6.81,2.46-6.73,5.95s2.25,6.43,4.45,8.92h-.08l-7.2,1.26Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M364.71,252.19C358.14,258,351.22,266,342.45,268.3c-6.88,1.78-14.11-.25-20.25-3.43-13.51-7-26.32-21.69-21.65-37.93,1.87-6.49,10.42-14.2,17.74-11.8,3.75,1.24,6.61,4,9.74,6.29a16,16,0,0,0,13.54,3c9.78-2.12,14.35-6.93,22.44-12.33a7,7,0,0,1,5.45-1.34A18.33,18.33,0,0,1,380,217.22c2.34,3.63,1.83,9.32,2,13.45s-.92,7-4.05,9.87C373.58,244.49,369.12,248.31,364.71,252.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.17,255.61c5.68-5.68,11.24-11.47,16.85-17.22,0,0,0-.1,0-.06-4.75,4.6-9.56,9.13-14.25,13.79s-9,9.59-14,13.74c-11.18,9.33-25.17,1.36-32.36-8.74-.33-.46-1,.11-.68.56,6.6,8.67,17.63,16.48,28.91,11.64C352.77,266.68,357.52,260.26,362.17,255.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.05,212.15c.12-.1,0-.27-.16-.18-6.47,4.72-13.57,10.84-21.86,11.65a20.37,20.37,0,0,1-11.78-2.44c-2.84-1.58-4.92-4-7.37-6.07-9.57-8.07-22.59,2.22-22.05,13.23,0,.23.41.22.41,0,0-8,5.78-15.35,14.2-15.53,6.76-.15,10.37,7.07,16.14,9.64C344.54,227.75,356.13,219.62,365.05,212.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,292.27s-.73-6.91-.69-8.34,7.34-6.36,7.34-6.36,1.72-13.2,3.1-16.18c.38-.83,12.83-2,14.45-.52s9.59,31.94,9.59,31.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,292.27s-.73-6.91-.69-8.34,7.34-6.36,7.34-6.36,1.72-13.2,3.1-16.18c.38-.83,12.83-2,14.45-.52s9.59,31.94,9.59,31.94Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.13,257.1c7,14,18.34,30.07,22,32.23,4.69,2.73,28.25,2.51,29.54,2.34,3.19-.44,2.94-22.09-.49-21.77-5.21.49-19.49,2.51-20.86,1.65s-11.52-8.79-22.14-17.89C368.89,247.37,363.79,248.42,368.13,257.1Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.83,267.66A17.11,17.11,0,0,1,440,269.07c3.23,1.6,3.9,7.17,3.32,8.4s-5.44,8.32-8.69,6.79,1.49-6.51,1.69-7.24.48-1.66-.16-1.88-13.8-.21-13.8-.21Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.41,267.55c.18.08,10.52.76,13.75,2.36s3.89,7.17,3.31,8.4-5.43,8.32-8.68,6.79,1.49-6.51,1.69-7.24.48-1.65-.17-1.88-13.79-.21-13.79-.21Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.88,284.16a4.25,4.25,0,0,1,.36-2.18,7.64,7.64,0,0,1,1.1-2,12,12,0,0,0,1.24-1.6,3.89,3.89,0,0,0,.36-1.93c0-.58-.58-.65-1.06-.7a19.29,19.29,0,0,0-2.15,0l-2.3.08a18.89,18.89,0,0,0-2.38.14.06.06,0,0,0,0,.11,19,19,0,0,0,2,0c.75,0,1.51,0,2.26,0s1.41,0,2.12,0a2,2,0,0,1,1,.15c.22.17,0,.84,0,1.06a3.37,3.37,0,0,1-.94,1.71,9.87,9.87,0,0,0-1.18,1.62,5.15,5.15,0,0,0-.66,1.76,7,7,0,0,0,.11,1.77C436.76,284.26,436.89,284.24,436.88,284.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.91,267.29c.2,0,10.47-1.33,13.95-.4s5.24,6.25,4.91,7.57-3.68,9.24-7.17,8.37.18-6.67.22-7.42.15-1.72-.53-1.82-13.56,2.53-13.56,2.53Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.52,282.1a4.35,4.35,0,0,1-.07-2.21,7.4,7.4,0,0,1,.68-2.2,13.38,13.38,0,0,0,.9-1.82,4.06,4.06,0,0,0,0-2c-.15-.56-.71-.52-1.19-.47a17,17,0,0,0-2.11.39c-.75.16-1.49.35-2.24.52a19.46,19.46,0,0,0-2.3.62c-.06,0-.05.11,0,.1a18.46,18.46,0,0,0,2-.36l2.23-.42c.69-.12,1.38-.28,2.08-.39a2.08,2.08,0,0,1,1,0c.25.12.22.81.22,1a3.38,3.38,0,0,1-.58,1.86,9.38,9.38,0,0,0-.84,1.82,5.37,5.37,0,0,0-.3,1.86,7.34,7.34,0,0,0,.46,1.71C441.42,282.22,441.55,282.17,441.52,282.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.78,
    y: 266.35,
    width: 5.41,
    height: 38.14,
    transform: "translate(705.95 739.76) rotate(-153.09)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.3,
    y: 283.7,
    width: 10.26,
    height: 6.1,
    transform: "translate(127.6 -137.67) rotate(20.34)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.58,
    y: 284.14,
    width: 6.67,
    height: 8.56,
    transform: "translate(128.46 -139.12) rotate(20.34)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.05,271.21s11.64-3.26,14.36-3.66c3.6-.54,9.25,1.23,9.44,4.1,0,.83-3.58,4.31-3.84,5-.74,1.85-.61,6,2.46,7.37s7.12-2.14,10.13-1.32-1.23,5.06-4.59,7.08a20.54,20.54,0,0,1-11.15,2.5c-3.08-.25-12.84-.59-12.84-.59Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.23,283.62c-1.56.34-3.39.87-4.92.22s-2.11-2.16-2.23-3.76a6.4,6.4,0,0,1,1.18-4.57,7.81,7.81,0,0,1,3.68-2.41,19,19,0,0,1,5.4-.79c.08,0,.06-.13,0-.13-1.69,0-6.86-.31-9.54,3.11a6.53,6.53,0,0,0-1.17,4.67,4.64,4.64,0,0,0,1.94,4c1.72,1,3.95.26,5.75-.22C442.38,283.68,442.31,283.6,442.23,283.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,268.31l-1.81,26.4s-22.41-.92-27.24-4.13-17.06-22.82-21.64-32.66.71-10.84,7.09-5.49,22.16,18.27,22.92,18.45S419,268.31,419,268.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.5,284.3c.24-3.12.5-6.24.62-9.37.07-1.78.15-3.55.21-5.33,0-.07-.12-.08-.12,0-.37,3.12-.72,6.25-.95,9.39s-.46,6.24-.64,9.36c-.1,1.78-.15,3.55-.14,5.33,0,0,.06,0,.06,0C412,290.57,412.26,287.44,412.5,284.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.33,292.08l-.18,2.63s-22.42-.92-27.24-4.12-17.06-22.83-21.64-32.67c-3.35-7.19-1.42-9.67,2.35-8.38C382.34,260,404.48,279.9,417.33,292.08Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.27,299.93l52.43.86-4.11-15.7s4.35-4,2.19-11.89c-1.25-4.62-7.06-13.34-10.71-17.73-8.91-10.71-16.65-5.87-19.12-3.12C347.52,262.87,336.27,299.93,336.27,299.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.19,250.49l11.69.27.47.31-12.59-.29C358.9,250.68,359,250.58,359.19,250.49Zm-4.08,4.21,20.7.47-.26-.31-20.22-.46Zm-2.47,3.93,26.33.61-.22-.3-25.93-.59A2.68,2.68,0,0,0,352.64,258.63Zm-2.09,4,31.18.72c-.07-.1-.13-.21-.2-.32l-30.84-.7C350.64,262.39,350.59,262.49,350.55,262.59Zm-1.9,4,35.52.81-.17-.29-35.21-.81Zm-1.74,4,39.25.9c0-.1-.08-.2-.12-.31l-39-.89Zm-1.64,3.95,42,1c0-.09,0-.19,0-.29l-41.82-1C345.34,274.27,345.3,274.37,345.27,274.46Zm-1.57,4,43.53,1c0-.1,0-.2,0-.3l-43.45-1Zm-1.49,4,43.66,1,.16-.29-43.71-1Zm-1.43,4,44.4,1-.08-.3-44.21-1C340.84,286.16,340.82,286.26,340.78,286.36Zm-1.39,4,46.84,1.08-.08-.3L339.5,290A2.49,2.49,0,0,1,339.39,290.32Zm-1.32,4,49.22,1.13-.08-.31-49-1.12Zm-1.28,4,51.55,1.18-.08-.31L336.88,298C336.84,298.07,336.82,298.18,336.79,298.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.56,284.17a46,46,0,0,1,6.74-.11c1.12.08,2.22.21,3.33.36.55.08,1.11.14,1.66.19a6.76,6.76,0,0,0,1.74,0c.06,0,.07.07,0,.08a11.31,11.31,0,0,1-1.63.27,12.2,12.2,0,0,1-1.6,0c-1.14-.07-2.27-.19-3.4-.28-2.28-.16-4.56-.32-6.85-.32A.1.1,0,0,1,370.56,284.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.46,287.11a50.25,50.25,0,0,1,5.43-1.25c.91-.16,1.83-.26,2.76-.34l1.32-.09c.49,0,1,0,1.47,0,.05,0,.07.07,0,.07-.45.05-.91.17-1.36.24l-1.37.21-2.75.44c-1.83.27-3.66.55-5.48.88C365.39,287.28,365.37,287.14,365.46,287.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.13,251c.27.94,5.1,6.87,9.43,6.45,1.41-.14,1-7.86,1-7.86l.1-.57L375,241l-9.68-5.56-1.4-.73s-.23,2.24-.5,5l0,.4c0,.16,0,.31-.05.45-.05.42-.09.84-.13,1.27s-.05.63-.07,1,0,.67-.07,1A53,53,0,0,0,363.13,251Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.46,239.7a16.48,16.48,0,0,0,10.19,9.35L375,241l-9.68-5.56-1.4-.73S363.73,236.92,363.46,239.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.34,226.46c3.82,13.87-4,17.72-7,18.54-2.71.75-12.05,2.94-17.28-10.46S361,215,367.14,213,381.52,212.6,385.34,226.46Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.73,224.61c-.34,0-.66,0-1,0a1.63,1.63,0,0,1-1-.16.51.51,0,0,1-.15-.6,1.27,1.27,0,0,1,1.14-.6,1.89,1.89,0,0,1,1.3.36A.55.55,0,0,1,382.73,224.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,226.58c.32-.12.59-.28.9-.43a1.59,1.59,0,0,0,.82-.62.51.51,0,0,0-.15-.61,1.29,1.29,0,0,0-1.29,0,1.87,1.87,0,0,0-1,.93A.54.54,0,0,0,373,226.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.23,229.85s-.07.07-.05.11c.29.93.46,2-.3,2.6,0,0,0,.07,0,.05C376.9,232.18,376.65,230.69,376.23,229.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.11,229.1c-1.55.3-.83,3.38.61,3.1S376.41,228.84,375.11,229.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.54,229.4c-.22.24-.41.61-.73.72s-.73-.13-1-.38c0,0-.06,0,0,0,.13.6.5,1.15,1.15,1.09s.89-.68.9-1.3C374.77,229.45,374.64,229.31,374.54,229.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.48,228.41s.08,0,.09.06c.19,1,.56,2,1.5,2.16,0,0,0,.05,0,.05C382,230.77,381.5,229.35,381.48,228.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.1,227.21c1.51-.46,2.33,2.59.94,3S380.84,227.6,382.1,227.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.8,227.24c.28.1.6.33.89.27s.5-.46.63-.83c0,0,0,0,.05,0a1.19,1.19,0,0,1-.38,1.5c-.49.24-1-.16-1.29-.71C382.64,227.39,382.68,227.21,382.8,227.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378,237.7a1.48,1.48,0,0,0,.91.42,2.6,2.6,0,0,0,1-.44s.07,0,.05,0a1.29,1.29,0,0,1-1.12.75,1,1,0,0,1-.92-.7C377.85,237.71,377.92,237.68,378,237.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.08,233.28a21.24,21.24,0,0,1,.71,2c0,.07-.13.14-.36.21h0a3.26,3.26,0,0,1-3.38-.42c-.06-.05,0-.14.08-.12a5,5,0,0,0,3.11.12c0-.2-1-2.32-.91-2.35a5.61,5.61,0,0,1,1.6,0c-1.06-2.89-2.57-5.58-3.58-8.48a.1.1,0,0,1,.17-.08,50,50,0,0,1,4.24,9C382.88,233.49,381.38,233.33,381.08,233.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.25,235.23a4,4,0,0,1-1.13,1.67,1.82,1.82,0,0,1-1,.41c-.81,0-1.06-.64-1.11-1.27a4.24,4.24,0,0,1,0-1A5.18,5.18,0,0,0,381.25,235.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.12,236.9a1.82,1.82,0,0,1-1,.41c-.81,0-1.06-.64-1.11-1.27A1.86,1.86,0,0,1,380.12,236.9Z",
    style: {
      fill: "#ff9bbc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.69,236.15a6,6,0,0,0,2.26-5.44,15.54,15.54,0,0,0,5.15-6.31c0,.31-.27,2.56-.43,3.7,8.63-3.57,10-11,10-11a15.89,15.89,0,0,1,5.12,4.86s-1.1-5.52-4.72-8.61a9.07,9.07,0,0,0-9-1.93,13,13,0,0,0-11.59,6.44C354,225.42,361.69,236.15,361.69,236.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.19,225.17a17,17,0,0,1-4.25,2.67s0,0,0,0a14.39,14.39,0,0,0,5.75-5.38,13.54,13.54,0,0,0,1.36-3.12,9.39,9.39,0,0,0,.47-3.68c0-.09.13-.1.14,0a10.89,10.89,0,0,1,0,3.69,9.92,9.92,0,0,1-1.37,3.39,11.36,11.36,0,0,1-2.13,2.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.26,236l-.62-.17c.08-.29.8-2.81,2.13-3.33s9.74-1.51,10.1-1.55l.07.63c-2.43.29-9,1.13-9.94,1.51S358.44,235.28,358.26,236Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.67,230.3l-.5-.39c.58-.74,2-1.89,3.43-.92l-.36.52C380,228.64,378.73,230.24,378.67,230.3Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.85,235.81a5.17,5.17,0,0,1-1.15.26,4.75,4.75,0,1,1,4-6.33,4.56,4.56,0,0,1,.28,1.48A4.76,4.76,0,0,1,375.85,235.81Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.4,226.73l-5.63,6.2a4.71,4.71,0,0,1-.17-2.54l3.24-3.58A4.75,4.75,0,0,1,375.4,226.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.16,228.67,372,235.5a5.39,5.39,0,0,1-.76-.52l6.38-7A4.52,4.52,0,0,1,378.16,228.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.78,230l-5.46,6-.21,0,5.61-6.2Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M385.65,233.65a1.81,1.81,0,0,1-.31,0c-1.81.18-3.63-1.51-4.15-3.94a5.56,5.56,0,0,1,.28-3.45,3,3,0,0,1,4.95-1.07,5.63,5.63,0,0,1,1.67,3C388.66,230.82,387.55,233.25,385.65,233.65Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.08,228.21l-4.57,5a4.51,4.51,0,0,1-1.37-1.29l5.14-5.68A5.92,5.92,0,0,1,388.08,228.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.49,224.61l-4.36,4.82a2.23,2.23,0,0,1,0-.23l4.22-4.66Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M362,239.36a2.81,2.81,0,0,0,.69,0,2,2,0,0,0,.67-.11,1.91,1.91,0,0,0,.76-.41,2.41,2.41,0,0,0,.46-.51,2.63,2.63,0,0,0,.39-.89l-1.48-3.64s-3.9-3.84-5.7-2.37S359.51,238.92,362,239.36Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.86,233.16s0,.06,0,.07a6.13,6.13,0,0,1,3.83,3.2,1.35,1.35,0,0,0-2.05,0s0,.09.07.08a1.49,1.49,0,0,1,1.71.21,8.15,8.15,0,0,1,1,1.17c.1.13.35,0,.26-.16l0,0C363.33,235.6,361.15,233,358.86,233.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.56,253.83c-8,8-27.86,38.74-22.1,44.67s40.7-1.22,50.14-5.33c2.8-1.22-8.71-19.18-12-18.73-2.72.38-16.73,5.42-17.1,4.61s2-7.47,5.74-19.36C364.6,246,359.09,250.29,355.56,253.83Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.52,279.84A69.29,69.29,0,0,1,377.81,270c4.34-2.53,14.39-7,27.47.32,3.11,1.74,6.3,6.41.2,5.42-4.33-.71-6.86-2.46-9.46-2.41,0,0,3.36,6.42,1.5,9.46a65.56,65.56,0,0,1-5.42,7.61,14.67,14.67,0,0,1-1.51-.89s-2,2.68-7,3.67Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.34,268.24c2.58.49,8,1.63,12.18,4.12,4.61,2.76,12.73,9.32,10.65,12.7-1.52,2.48-4.84.24-4.84.24s2.79,3.42.92,5.36c-1.69,1.76-4.16-.12-4.16-.12s1.33,2.37-.63,3.75c-2.36,1.66-4.77-3.56-8.61-3.94C387,290.26,382.34,268.24,382.34,268.24Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.8,276.74a21.39,21.39,0,0,1,9.54,8.45c.05.1,0,.19-.06.11a52.93,52.93,0,0,0-9.51-8.52S390.77,276.73,390.8,276.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.14,281.46a24,24,0,0,1,9,9c0,.1,0,.19-.06.11a56.65,56.65,0,0,0-9-9.08S388.12,281.45,388.14,281.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396,273.28a17.71,17.71,0,0,1,6.09,1.3,28,28,0,0,0,3.22.9c1,.21,2.46.53,3.15-.47a1.78,1.78,0,0,0-.13-1.83,9,9,0,0,0-1.86-2s0-.07,0-.05a12.65,12.65,0,0,1,1.9,1.75,2.92,2.92,0,0,1,.68,1.58c0,1.25-1.28,1.81-2.34,1.78a10.19,10.19,0,0,1-1.89-.3c-.59-.14-1.18-.31-1.77-.49-1.2-.38-2.37-.82-3.57-1.21a28.16,28.16,0,0,0-3.52-.84S396,273.28,396,273.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.62,279.33a68.86,68.86,0,0,0-6.64-6s0-.07,0-.06a36,36,0,0,1,7,5.52,12.11,12.11,0,0,1,2.63,4,2.53,2.53,0,0,1-1.18,3.31,3,3,0,0,1-1.95.26,6.14,6.14,0,0,1-2.17-1.08s0-.08,0-.06a4.23,4.23,0,0,0,3.68.6,2.12,2.12,0,0,0,1.14-1.14,2.69,2.69,0,0,0-.18-1.87A12.79,12.79,0,0,0,402.62,279.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.51,275.2l9.81,22.62s-41.7,7.88-45,.55,13.71-35,21.24-42.93c8.72-9.23,9.68-5.95,7.54,2.42-2.24,8.76-6.42,21.4-6.42,21.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.88,284.76a48.2,48.2,0,0,1,6.16-3.34,46.83,46.83,0,0,1,6.51-2.36c1.26-.37,2.54-.68,3.82-1,0,0,.05.05,0,.06a59.47,59.47,0,0,0-6.57,2.3c-2.13.86-4.25,1.77-6.36,2.71-1.19.54-2.35,1.13-3.52,1.7A0,0,0,0,1,341.88,284.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.4,275.13c-.21.05-12.21,3.5-12.59,3.66.05-.17,3.16-9.58,3.2-9.67.22-.38,1.35-2.45,1.61-3,0,0,0,0,0,0-.29.49-1.16,1.67-1.28,1.9.23-.62,1.21-3.78,1.51-4.78,0,0,0,0-.05,0-1.55,2.88-6.09,16.58-6.07,16.57s13.49-4.44,13.73-4.53A.08.08,0,0,0,367.4,275.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.66,289.68c-1.07-2.53-2.13-5.06-3.31-7.54-.66-1.41-1.32-2.83-2-4.24,0,0-.12,0-.1,0,1,2.58,2,5.16,3.07,7.69s2.17,5.05,3.3,7.55q1,2.15,2.05,4.21a0,0,0,0,0,.05,0C369.83,294.76,368.75,292.22,367.66,289.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.85,298.19c-.4-.7-.88-1.71-1.3-2.39-.11-.18-.25-.15-.16,0,.29.63.53,1.34.82,2l-1.76.28-2,.36c-1.32.22-2.65.43-4,.63q-4,.6-8.1,1a159,159,0,0,1-16.33,1c-1.52,0-3,0-4.57-.1a42,42,0,0,1-4.5-.37s-.05.06,0,.07a25.81,25.81,0,0,0,3.9.65c1.38.11,2.76.19,4.14.22,2.75.06,5.51,0,8.25-.18,5.45-.31,10.89-.86,16.29-1.62,1.52-.22,3-.45,4.54-.7l2.28-.39A14.69,14.69,0,0,0,377.85,298.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.31,281.16a24.52,24.52,0,0,0-6.26,4.64c-2.49,2.75-5.66,11.32-5.66,11.32s28.55,2.91,28.47.78S461.31,281.16,461.31,281.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.88,287.6S262,263,260.37,261.89s-24.47-1.24-26-.25-2.28,11.77-3.58,12-9.09,1.14-11.6,2.07-2.62,9.24-2.62,9.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.88,287.6S262,263,260.37,261.89s-24.47-1.24-26-.25-2.28,11.77-3.58,12-9.09,1.14-11.6,2.07-2.62,9.24-2.62,9.24Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.22,404.72l-123.47.82s6.6-76.37,66-71.24S629.22,404.72,629.22,404.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.22,404.72l-123.47.82s6.6-76.37,66-71.24S629.22,404.72,629.22,404.72Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.66,404.64l-123.12-9.3s12.83-75.58,71.61-65.59S259.66,404.64,259.66,404.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.66,404.64l-123.12-9.3s12.83-75.58,71.61-65.59S259.66,404.64,259.66,404.64Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533,290.64l2.62,1.5s-16.55,1.53-20.2,1.12S447,252.71,446.1,252.32,403.05,236,403.05,236s57.75,18.39,61.48,19.74S533,290.64,533,290.64Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.56,392.8s-12.46,11.39-16.33,12.45-39.7,4.27-41.82,3.57S632.23,343,571,339.35s-54.5,72.2-56,72.17-261.61-2-262.78-3.07,7.86-69.85-51.6-70.6c-56.93-.72-53.69,62.25-55.94,62.32S98.76,395,95.09,394s-9-11.61-9.39-12.53.77-3.35.77-3.35-5.64-18-5.93-25.16,13.2-27.05,13.2-27.05l9.47-31.87s-4.42-2.64-5-3.55S97,286.15,97,286.15l91.26-7.5a19.4,19.4,0,0,1,3.32-1.87c1-.26,6.87-.43,6.87-.43s9.56,7.24,13.47,8.18S475,298.14,476.44,297.68,440.79,260.53,437,257.05s-36.08-12.39-36.47-13.34-.48-8.5.54-8.39S442.84,250.4,447.51,253s67,39.39,68.84,40.12,19.1-.86,19.27-1S533,291,533,290.64s4.59.7,5.58.7,75.38,11.08,87.61,15.43,30.49,15.56,38.69,23.44S680.63,350.09,682,350.9s4.67,1,5.25,6.23-.16,10.6-1.32,11.72-4.89,2.29-5.27,2.72-.88,13-.69,13.46,1.7.82,1.86,1.93S682.32,391.55,681.56,392.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.8,364a65.45,65.45,0,0,0-3.69,8.49c-45-1.41-249.09-7.91-248.69-9.89S488.87,363.45,524.8,364Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.82,
    cy: 392.32,
    r: 48.99,
    transform: "translate(102.69 902.62) rotate(-82.08)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.82,
    cy: 392.32,
    r: 35.77,
    transform: "translate(-109.38 260.81) rotate(-23.59)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.82,
    cy: 392.32,
    r: 32.98,
    transform: "translate(-110.52 517.83) rotate(-45)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.5,384.88l10.25-1.49c-4.19-4.49,5.33-23.69,5.33-23.69l-5.65-1c-2.69,6.68-4.22,8.75-7.17,9.18s-5-1.12-9.51-6.75l-5.11,2.59S566.23,379.38,563.5,384.88Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.7,383.89l4.59,9.29c3-5.37,24.17-2.25,24.17-2.25l-.78-5.7c-7.18-.49-9.62-1.31-10.94-4s-.48-5.11,3.48-11.12l-4-4.07S580.78,384.79,574.7,383.89Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.11,394.23l-7.42,7.24c6,1.17,9.61,22.29,9.61,22.29l5.18-2.5c-1.75-7-1.73-9.55.41-11.63s4.7-2.05,11.65-.13l2.62-5.1S580.13,400.29,579.11,394.23Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.63,401.62l-9.17-4.82c.75,6.1-18.23,16-18.23,16l4,4.15c6.1-3.82,8.55-4.59,11.19-3.21s3.4,3.85,3.73,11.05l5.66.91S565.19,404.47,570.63,401.62Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561,395.84l1.74-10.21c-5.56,2.59-20.88-12.39-20.88-12.39l-2.71,5.06c5.52,4.63,7,6.72,6.5,9.66s-2.6,4.42-9.35,7l.88,5.67S556.6,391.54,561,395.84Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.31,393.47a9.57,9.57,0,1,0,8.09-10.85A9.57,9.57,0,0,0,560.31,393.47Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.87,
    cy: 392.44,
    r: 48.99,
    transform: "translate(-177.93 165.32) rotate(-32.05)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.87,
    cy: 392.44,
    r: 35.77,
    transform: "translate(-228.48 287.9) rotate(-49.38)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.87,
    cy: 392.44,
    r: 32.98,
    transform: "translate(-233.65 472.94) rotate(-73.67)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.56,385l10.25-1.49c-4.19-4.5,5.33-23.69,5.33-23.69l-5.66-1c-2.69,6.68-4.22,8.75-7.17,9.18s-5-1.12-9.5-6.75l-5.12,2.59S195.29,379.5,192.56,385Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.76,384l4.58,9.28c3-5.37,24.18-2.25,24.18-2.25l-.78-5.69c-7.18-.49-9.62-1.31-10.94-4s-.49-5.11,3.48-11.13l-4-4.06S209.83,384.9,203.76,384Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.16,394.35l-7.41,7.23c6,1.18,9.61,22.3,9.61,22.3l5.17-2.5c-1.75-7-1.72-9.55.41-11.64s4.71-2,11.65-.12l2.62-5.11S209.19,400.41,208.16,394.35Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.69,401.74l-9.17-4.82c.74,6.1-18.24,16-18.24,16l4,4.15c6.1-3.82,8.55-4.59,11.19-3.21s3.4,3.85,3.72,11l5.66.92S194.24,404.58,199.69,401.74Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,396l1.75-10.21c-5.57,2.59-20.88-12.39-20.88-12.39l-2.72,5.06c5.52,4.63,7,6.72,6.51,9.66s-2.61,4.42-9.35,6.95l.88,5.67S185.65,391.66,190,396Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.36,393.59a9.57,9.57,0,1,0,8.1-10.85A9.59,9.59,0,0,0,189.36,393.59Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.81,295.47c-3.46,1-10.18,10.36-10.51,12.19s-.79,13.87.62,15.45,6.25,5.3,9.89,4.92,26.65-11.28,28-13,1.26-10.67-1-13.23S107.22,294.24,102.81,295.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.84,315.08c-1.38,1.68-24.39,12.57-28,12.95-2.77.29-6.25-1.82-8.36-3.53,2.89,1.3,5.48,1.68,7.4,1.2s24-9.91,25.83-12.16.86-9.61.39-10.89-18.83-7-18.83-7c8.28.75,19,4.43,20.56,6.16C132.09,304.4,132.22,313.39,130.84,315.08Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.05,319.67c2.48,5.77,25.11,18.67,33.86,21.46,5.51,1.76,24.91,5.87,26.19,5s-6.22-15.31-10.63-19.21-27.64-15.67-35.08-16.42S615.54,313.84,618.05,319.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.11,346.15c-1.29.86-20.68-3.26-26.2-5-8.75-2.8-31.38-15.69-33.87-21.47s6.91-9.88,14.35-9.14a12.86,12.86,0,0,1,1.72.29c-7.25,1.52-9.45,6.69-5.71,10.38s16.1,12.84,21.25,15.13c5,2.21,23.79,8.05,25.64,7a3.37,3.37,0,0,0,1.14-2.66C677.81,343.55,678.59,345.83,678.11,346.15Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M623,400.08c.12,5.2-.07,8.58.41,8.74,2.12.7,37.94-2.49,41.82-3.57s16.33-12.46,16.33-12.46.06-.1.08-.16a146.67,146.67,0,0,1-40.35,7.47C638.79,400.19,632.46,400.18,623,400.08Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M251.67,392.11c.75,9.24.14,16,.5,16.34,1.16,1.1,261.25,3,262.77,3.07.41,0,.22-5.44.91-13.35C436.41,396.51,333.85,394.13,251.67,392.11Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7,381.5c.39.92,5.71,11.56,9.39,12.53s47.27,6.22,49.52,6.15c.59,0,.81-4.35,1.83-10.73a356.43,356.43,0,0,1-43.09-3.84,46.66,46.66,0,0,1-16.88-7.46S85.31,380.59,85.7,381.5Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M494.72,397.72c0-15.23.51-37.38.8-52.84.11-4.4.22-8.8.28-13.2a5.4,5.4,0,0,0-.2-2.25c-3.46-6.49-15.23-25.18-19.16-31.75,6.13,9.14,12.19,18.34,17.92,27.75.76,1.46,2,2.94,2.33,4.55-.12,22.6-1,45.17-2,67.74Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M308.38,289.8l-3.17,12.66c-1.11,5.24-3,10.52-3.13,15.87.56,18.62,1.1,43.3,1.3,62l.06,13.05-.55-13c-.63-17.37-1.27-41.39-1.58-58.72,0-1.92-.23-4.7.25-6.58,1.86-8.54,4.33-16.88,6.82-25.22Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M157.64,358.37c-8.91-4.56-17.7-9.35-26.31-14.47a15.94,15.94,0,0,1-3.94-3.7c-1.54-1.78-3.08-3.57-4.55-5.41-3-3.66-5.88-7.35-8.69-11.13l4.66,5.3c3.52,3.93,8.2,9.77,11.95,13.43,8.89,5.42,18,10.46,26.88,16Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M617.32,316c-23.57-3-47.49-6.21-70.94-10.14-10.2-3.84-20.06-8.35-30-12.71,4.68,1.8,26,10.45,30.25,11.87,22.25,3.53,48.55,7.19,70.72,11Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M346,320.47c-.63,2.17-1.47,4.86-3.69,5.89a53,53,0,0,1-9,.23,54.59,54.59,0,0,1-8.91-.9,3.62,3.62,0,0,1-1-.38c-1.54-1.41-2.12-3.44-2.75-5.34.85,1.67,1.67,3.63,3.11,4.82a7.59,7.59,0,0,0,1.78.35c5.19.43,10.5.59,15.71.62a2.26,2.26,0,0,0,1.65-.46,12.93,12.93,0,0,0,3.13-4.83Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M346.18,317.07c-.51-1.78-1.11-4-2.6-5.09a9.68,9.68,0,0,0-1.86-.33,93.42,93.42,0,0,0-12-.29c-2.71,0-5.16.51-7.06,2.56A12.24,12.24,0,0,0,320.2,317a10.88,10.88,0,0,1,2.16-3.42,9.65,9.65,0,0,1,3.29-2.5,16.64,16.64,0,0,1,4.07-.67,58.41,58.41,0,0,1,12.11.48,9.53,9.53,0,0,1,2.06.54c1.68,1.38,2,3.65,2.29,5.64Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M345.36,316.86c4.13.9,3.87,3.32-.26,3.82-5.17.51-10.37.44-15.55.46-3.2-.23-6.74.4-9.81-1-1.55-.76-2-2.48-.21-3.34,3.27-1.27,6.92-.6,10.31-.74a154.36,154.36,0,0,1,15.52.81Zm0,0c-7.67-.84-15.55-.39-23.23.15-1.27.11-4.28,1-1.93,2.26,1.68.86,3.6.69,5.49.84,6.42.23,13,.77,19.39.43,4.09-.37,4.38-2.74.28-3.68Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M680.67,371.57s-23.32,2.07-23.61,2-1-3.28-2.95-3.37-8.72,5.69-9.8,11.25.19,9.73,3.72,9.31,8.35-7.56,8.35-7.56,17.9-1,18.33-.67A19.52,19.52,0,0,0,677,384.3a16.2,16.2,0,0,0,3,.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.2,308.09c-1.58-2.37,2.17-20,3.9-21.17s21.65,1.52,21,12.82S461.66,311.8,459.2,308.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.2,308.09c-1.58-2.37,2.17-20,3.9-21.17s21.65,1.52,21,12.82S461.66,311.8,459.2,308.09Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.41,366.57c-5.21-16.69-17.64-31.07-33.83-37.83-18.85-7.57-41.79-7.37-59.21,3.77a63.81,63.81,0,0,0-24,29,61,61,0,0,1,9.08-16.94c16.93-22.8,46.78-28,72.52-18.35,17.5,6.52,31,22.43,35.39,40.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.9,367.67c-5.21-16.7-17.64-31.08-33.83-37.84-18.85-7.57-41.79-7.36-59.21,3.78a63.76,63.76,0,0,0-24,29A61.08,61.08,0,0,1,522,345.64c16.93-22.79,46.78-28,72.52-18.35,17.5,6.52,31,22.44,35.39,40.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.52,320c-78.3-3-157.39-7.35-235.54-13,78.3,3,157.39,7.36,235.54,13Z",
    style: {
      fill: "#fff"
    }
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrive);
export default __webpack_public_path__ + "static/media/drive.900632e7b789b93e47636a1f4139ca00.svg";
export { ForwardRef as ReactComponent };